__webpack_require__.p = "https://bmidxbmalaysiaplprod.netlify.app/";